import { lazy, useContext } from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

import { useUserData } from "src/context/userContext";
import { KeikkaDataContext } from "src/context/KeikkaDataContext";
import {
  deleteKeikka,
  kunPumppuToimittajaVastaanottaaTilauksen,
} from "src/data/keikka/handleKeikka";
import { newStepLogMessage } from "src/data/stepLog/stepLogMessageClass";

import MySkeleton from "src/components/layout/MySkeleton";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
const KeikkaTilaBox = lazy(() =>
  import("src/components/keikka/keikkaTila/KeikkaTilaBox/KeikkaTilaBox")
);

const TilaDropDown = lazy(() =>
  import("src/components/keikka/keikkaTila/TilaDropDown/TilaDropDown")
);

const styles = {
  alignRight: { display: "flex", justifyContent: "flex-end" },
  padRight: { paddingRight: "5px" },
  alignLeft: { textAlign: "left" },
};
export default function TilaRow(props) {
  const { keikkaData, doSetKeikkaData: setKeikkaData } = useContext(KeikkaDataContext) || {};

  const { user, token, socket } = useUserData();

  const handleTilaSave = async (newKeikkaTilaId) => {
    const oldKeikkaTilaId = keikkaData.tila.keikkaTilaId;
    const personId = user.personId;
    keikkaData.tila.keikkaTilaId = newKeikkaTilaId;
    await keikkaData.setAuthDataViaFetch(
      personId,
      keikkaData.keikkaId,
      keikkaData.tyomaa.tyomaaId,
      keikkaData.asiakas.asiakasId,
      keikkaData.tila.keikkaTilaId,
      token
    );
    await keikkaData.tila.saveKeikkaTilaToDB(personId, token, true, socket, keikkaData.varmenne);
    if (newKeikkaTilaId == 10) await deleteKeikka(keikkaData, personId, token, socket);
    setKeikkaData(keikkaData);

    if (oldKeikkaTilaId > 2) {
      const sl = newStepLogMessage(
        "Asetettu tilaan: " + keikkaData.tila.keikkaTilaSelite,
        personId,
        keikkaData,
        11
      );
      sl.addMessageOnlyIfVarmenneChanged = true; // varmenne ei muutu mikäli tila muuttuu, jos tilauksessa ei ole muutoksia, niin ei laita merkintää
      sl.isSystemMessage = true;
      await sl.saveToDB(socket);
    }
  };
  const handleTilaChange = async (newKeikkaTilaId) => {
    keikkaData.tila.origKeikkaTilaId = newKeikkaTilaId;
    keikkaData.tila.keikkaTilaId = newKeikkaTilaId;
    //keikkaData.tila.keikkaTilaSelite = keikkaData.tila.fetchKeikkaTilaSelite(newKeikkaTilaId);
    await keikkaData.tila.reloadTilaDataFromAPI();
    setKeikkaData(keikkaData);
  };
  const vastaanotaTilaus = async () => {
    const personId = user.personId;
    await kunPumppuToimittajaVastaanottaaTilauksen(keikkaData, personId, token, socket);
    setKeikkaData(keikkaData);
  };

  return (
    <>
      <div className="spaceBetween">
        <Grid container className="transitionElement" sx={{ width: "100%" }}>
          <Grid size={{ xs: 3 }} sx={styles.alignRight}>
            <Typography
              variant="h6"
              sx={styles.padRight}
              color="primary"
              className="fixPrint transitionElement">
              Tila:
            </Typography>
          </Grid>
          {keikkaData.isLoading ? (
            <MySkeleton width="70%" height="35px" />
          ) : (
            <>
              <Grid size={{ xs: 9 }} sx={styles.alignLeft}>
                <LazyLoader txt={"Ladataan tilat"}>
                  <>
                    <div>
                      {keikkaData.auth.isKeikkaAdmin && keikkaData.tila.muokkausTila ? (
                        <TilaDropDown
                          keikkaTilaId={
                            keikkaData.tila.muokkausTila
                              ? keikkaData.tila.origKeikkaTilaId
                              : keikkaData.tila.keikkaTilaId
                          }
                          onChange={handleTilaChange}
                          onSave={handleTilaSave}
                          vastaanotaTilaus={vastaanotaTilaus}
                          isStepLogAccepted={keikkaData.tila.isStepLogAccepted}
                          keikkaId={keikkaData.keikkaId}
                        />
                      ) : (
                        <LazyLoader txt={"Ladataan tilat"}>
                          <KeikkaTilaBox
                            buttonText={props.buttonText}
                            buttonClick={props.buttonClick}
                            tila={keikkaData.tila} // this makes the component re-render when tila changes
                            isTarjouspyyntö={props.isTarjouspyyntö}
                          />
                        </LazyLoader>
                      )}
                    </div>
                  </>
                </LazyLoader>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </>
  );
}
TilaRow.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  buttonClick: PropTypes.func,
  isTarjouspyyntö: PropTypes.bool,
};
